import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL, uploadFile } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { ColumnsType } from "src/interfaces/Common";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import AddEditFormNewCst from "@components/AddEditFormNewCst";
import { MethodType } from "src/services/type";

interface Props {
  externalCertificate: any;
  onSuccess: () => void;
  onlyVisualization?: boolean;
}

const EditModalCompletions: React.FC<Props> = ({
  externalCertificate,
  onSuccess,
  onlyVisualization = false,
}) => {
  const { t } = useTranslation(["rooms-page"]);
  const { id = "1" } = useParams();
  const [editColumns, setEditColumns] = useState<ColumnsType | any>();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  const { columns, dataDetail, mutate } = useFetchDetail(
    ServicesURL.getExternalCertificate,
    externalCertificate?.id,
    PagesID["skillBook-edit-completions"],
  );

  const onSubmit = async (inputForm: any) => {
    const objectToSend = {
      ...inputForm,
      learnerId: dataDetail?.learnerId,
      corporateId: dataDetail?.corporateId,
      uploadByAdmin: true,
      externalTrainingId: dataDetail?.externalTrainingId,
      link: inputForm.url,
    };

    let formData = new FormData();
    formData.append(
      "certificate",
      inputForm.pdfKey?.e ? inputForm.pdfKey.e : null,
    );
    (inputForm?.attachmentsArray ?? []).forEach((file: any) =>
      formData.append("attachments", file.file),
    );

    if (
      objectToSend.duration === undefined ||
      isNaN(objectToSend.duration) ||
      Number(objectToSend.duration) < 0
    )
      return;

    objectToSend.durationParticipation = Number(
      inputForm.durationParticipation,
    );

    formData.append("data", JSON.stringify(objectToSend));

    try {
      if (formData) {
        await uploadFile(
          `${ServicesURL.putExternalCertificate}/${externalCertificate.id}`,
          formData,
          MethodType.PUT,
          "multipart/form-data",
        );
        setOpenToast({ s: StatusEnum.OK, message: "" });
      }
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
    mutate && mutate(formData);
  };

  useEffect(() => {
    if (columns) {
      const sitesCodeIndex = columns.findIndex(
        (item) => item.accessorKey === "code",
      );
      const sitesCodeObject = { ...columns[sitesCodeIndex], disabled: true };
      columns[sitesCodeIndex] = sitesCodeObject;
      setEditColumns(columns);
    }
  }, [dataDetail]);

  const heroTitle = onlyVisualization
    ? "Visualizza informazioni"
    : "Modifica Informazioni";

  const inputsException = (col: any, inputForm: any) => {
    if (col?.accessorKey === "durationMinutes") {
      if (inputForm["durationMinutes"] === undefined) {
        col.error = "required-course-duration";
      } else if (isNaN(inputForm["durationMinutes"])) {
        col.error = "type-number-value-error";
      } else if (Number(inputForm["durationMinutes"]) < 0) {
        col.error = "negative-value-error";
      } else {
        col.error = "";
      }
    }
    return col;
  };

  return (
    <>
      <HeroCst title={heroTitle} description={t("edit.hero-description")} />
      <Box>
        <AddEditFormNewCst
          testIdPrefix="skillbook-completion-edit-form"
          row={dataDetail || []}
          actionsForForms={[]}
          columns={editColumns}
          inputsException={inputsException}
          onSubmit={onSubmit}
          backButton={onSuccess}
          readOnly={onlyVisualization}
          externalCertificate={true}
        />
      </Box>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-edit")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
          mutate && mutate();
          onSuccess();
        }}
        status={openToast}
        routeToSamePage={true}
      />
    </>
  );
};

export default EditModalCompletions;
